// extracted by mini-css-extract-plugin
export default {"template-wrapper":"Template_template-wrapper__6y6Ij"};